import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormManagerService } from '@sim/form';
import { BaseFiltersComponent, FilterFieldsOptions } from '@ui/ui.module';

import { cardS } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-card-s-filters',
  styleUrls: ['./card-s-filters.component.scss'],
  templateUrl: './card-s-filters.component.html',
})
export class CardSFiltersComponent extends BaseFiltersComponent<cardS.CardSFilter, FilterFieldsOptions<cardS.CardSFilter>> {
  constructor(
    protected readonly formManager: FormManagerService,
  ) {
    super(formManager, cardS.CardSFiltersMeta);
  }

}
